import { $api } from "../../../store/api/api";

import { EndpointsEnum } from "../../../constants/endpoints";

import { IPostTicketChatBody, IPostTicketChat, IPostTicketChatResponse } from "./post-ticket-chat.types";
import { IRestResponse } from "../../../types/response";

export const postTicketChat: IPostTicketChat = async (body: IPostTicketChatBody) => {
    const response = await $api.post<IRestResponse<IPostTicketChatResponse>>(`${EndpointsEnum.POST_TICKET_CHAT}`, body);

    return response.data;
};
